import server from "@/utils/server";

const auth = {
  namespaced: true,
  state: {
    isAuthenticated: false,
    user: null,
    token: localStorage.getItem("token"),
  },
  mutations: {
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setToken(state, payload) {
      state.token = payload;
      localStorage.setItem("token", payload);
    },
  },
  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    user(state) {
      return state.user;
    },
    userId(state) {
      return state.user.id;
    },
  },
  actions: {
    async checkAuth({ state, commit }) {
      try {
        const token = state.token;
        if (!token) {
          this.isAuthenticated = false;
          this.user = null;
          return false;
        }

        const response = await server.post("/auth/check", {
          token: token,
        });
        commit("setIsAuthenticated", response.status === 200);
        commit("setUser", response.data);
        commit("setToken", response.data.token);
        return response.status === 200;
      } catch (e) {
        commit("setIsAuthenticated", false);
        commit("setUser", null);
        return false;
      }
    },
    async logout({ state, commit }) {
      try {
        await server.post("/auth/logout", {
          token: state.token,
        });
        commit("setToken", "");
        commit("setIsAuthenticated", false);
        commit("setUser", null);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
};

export default auth;
